import LegalPageLayout from "../components/LegalPageLayout";

function PrivacyPolicy() {

    return (

        <LegalPageLayout title="Privacy Policy & Data Protection Notice">

            <p className="legal-effective-date">Last updated: 2026</p>

            <p>
                Kinetiq Robotics Private Limited (KRPL) is dedicated to safeguarding both your
                operational metrics and your personal information. In accordance with the Digital
                Personal Data Protection (DPDP) Act, KRPL operates as a responsible Data Fiduciary
                for the personal data processed within this portal.
            </p>

            <h2>Data Collection &amp; Purpose</h2>
            <p>
                We collect user profile details (names, corporate emails, access logs) solely for
                account verification, security auditing, and portal access control. Machine
                diagnostic telemetry and robot performance logs are collected strictly to optimize
                hardware efficiency, predict maintenance cycles, and ensure industrial workplace
                safety.
            </p>

            <h2>Consent &amp; Rights</h2>
            <p>
                As a Data Principal, your employees retain the right to access, correct, or request
                the erasure of their personal digital data stored on our servers, except where data
                retention is legally required for operational safety audits.
            </p>

            <h2>Security &amp; Processing</h2>
            <p>
                KRPL processes all data legally, transparently, and securely, using advanced
                encryption protocols both in transit and at rest. We do not share personal or
                proprietary operational data with third parties without explicit, unambiguous
                consent.
            </p>

            <h2>Grievance Redressal</h2>
            <p>
                For queries regarding your data rights or to contact our designated Data Protection
                Officer (DPO), please contact our IT department using the information provided on
                the <a href="/contact-support">Contact Support</a> page.
            </p>

        </LegalPageLayout>

    );

}

export default PrivacyPolicy;
